export default __webpack_public_path__ + "static/media/netflix.33367857.jpg";